export default "__VITE_ASSET__CIvklJjJ__"